export default {
  name: 'marking--printJournal',
  apiService: 'shoes',
  apiPath: '/admin/print_journal',
};